<template>
    <div v-loading="loading.page">
        <el-dialog :title="'Update Service ' + (selectedService == 'line' ? `${selectedServiceObj.fields.bot.displayName}` : `#${selectedNumber.number}`)" :visible.sync="dialog.update" :before-close="done => { clear(); done() }">
            <el-form label-position="top">
                <el-form-item label="Phone Number" label-width="120px">
                    <el-input type="text" v-model="selectedNumber.number" disabled class="mt-10" />
                </el-form-item>
                <el-form-item label="Masking Phone Name" label-width="120px">
                    <el-input type="text" v-model="maskingName" class="mt-10" />
                    <!-- <el-autocomplete
                        style="width: 100%;"
						class="auto-input"
						v-model="maskingName"
						:fetch-suggestions="querySearch"
						placeholder="Search and Select"
						:trigger-on-focus="false"
						@select="handleSelect"
						></el-autocomplete> -->
                </el-form-item>
                <el-form-item label="Phone Status" label-width="120px">
                    <!-- <el-input type="text" v-model="phoneStatus" class="mt-10" /> -->
                    <el-select style="width: 100%;" v-model="phoneStatus">
                        <el-option v-for="s in options_phoneStatus" :key="s.value" :value="s.value" :label="s.label" />
                    </el-select>
                </el-form-item>
                <el-form-item label="Connection" label-width="120px">
                    <!-- <el-input type="text" v-model="connection" class="mt-10" /> -->
                    <el-select style="width: 100%;" v-model="connection">
                        <el-option v-for="s in options_connection" :key="s.value" :value="s.value" :label="s.label" />
                    </el-select>
                </el-form-item>
                <el-form-item label="PIC Business" label-width="120px">
                    <!-- <el-input type="text" v-model="selectedNumber.pic_business" class="mt-10" /> -->
                    <el-select @change="handleChangeSelectedPicBusiness" style="width: 100%;" v-model="adminId">
                        <el-option v-for="s in options_picBusiness" filterable :key="s.value" :value="s.user_id" :label="s.label" />
                    </el-select>
                </el-form-item>
                <el-form-item label="Notes" label-width="120px">
                    <el-input type="textarea" :rows="4" v-model="notes" class="mt-10" />
                </el-form-item>
                <el-form-item label="Service" label-width="120px">
                    <el-select @change="handleChangeSelectedService" v-model="selectedService">
                        <el-option v-for="s in options" :key="s.value" :value="s.value" :label="s.label" />
                    </el-select>
                </el-form-item>
                <el-form-item label="Inquiry URL" label-width="120px">
                    <el-input type="text" v-model="selectedServiceObj.inquiryUrl" class="mt-10" />
                </el-form-item>
                <el-form-item label="Token" label-width="120px">
                    <el-input type="textarea" :readonly="selectedService == 'line'" :rows="4" v-model="selectedServiceObj.fields.token" class="mt-10" />
                </el-form-item>
                <el-form-item v-if="selectedService == 'helpdesk'" label="BOT Position" label-width="120px">
                    <!-- <el-input type="text" v-model="connection" class="mt-10" /> -->
                    <el-select style="width: 100%;" v-model="bot_position">
                        <el-option v-for="s in options_botPosition" :key="s.value" :value="s.value" :label="s.label" />
                    </el-select>
                </el-form-item>
                <el-form-item v-if="selectedService == 'helpdesk'" label="Helpdesk Position" label-width="120px">
                    <!-- <el-input type="text" v-model="connection" class="mt-10" /> -->
                    <el-select style="width: 100%;" v-model="helpdesk_position">
                        <el-option v-for="s in options_helpdesk" :key="s.value" :value="s.value" :label="s.label" />
                    </el-select>
                </el-form-item>
                <el-form-item v-if="selectedService == 'helpdesk'" label="Botkit URL" label-width="120px">
                    <el-input type="text" v-model="botkit.url" class="mt-10" />
                </el-form-item>
                <el-form-item v-if="selectedService == 'helpdesk'" label="Botkit Plain" label-width="120px">
                    <el-radio-group v-model="botkit.plain">
                        <el-radio :label="true">Yes</el-radio>
                        <el-radio :label="false">No</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="selectedService == 'helpdesk' || selectedService == 'line'" label="Botkit Close Callback" label-width="120px">
                    <el-input type="text" v-model="botkit.close_callback" class="mt-10" />
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="loading.btnUpdate" @click="doUpdateService"><i class="mdi mdi-content-save"/> Update</el-button>
                <el-button @click="dialog.update = false">Close</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="'Update Webhooks ' + selectedServiceWH.fields.bot.displayName" :visible.sync="dialog.webhooks">
            <el-form label-position="top">
                <el-form-item label="Phone Number" label-width="120px">
                    <el-input type="text" v-model="selectedNumber.number" disabled class="mt-10" />
                </el-form-item>
                <el-form-item label="Webhook 1" label-width="120px">
                    <el-input type="text" v-model="webhooks_fields[0]" @input="WHField(0)" class="mt-10" />
                </el-form-item>
                <el-form-item label="Webhook 2" label-width="120px">
                    <el-input type="text" v-model="webhooks_fields[1]" :disabled="!webhooks_fields[0]" @input="WHField(1)" class="mt-10" />
                </el-form-item>
                <el-form-item label="Webhook 3" label-width="120px">
                    <el-input type="text" v-model="webhooks_fields[2]" :disabled="!webhooks_fields[1]" class="mt-10" />
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="loading.btnUpdate" @click="doUpdateWebhooks(selectedServiceWH)"><i class="mdi mdi-content-save"/> Update</el-button>
                <el-button @click="dialog.webhooks = false">Close</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="'Delete Service #' + selectedNumber.number" :visible.sync="dialog.delete" :before-close="done => { clear(); done() }">
            <el-form label-position="top">
                <el-form-item label="Phone Number" label-width="120px">
                    <el-input type="text" v-model="selectedNumber.number" disabled class="mt-10" />
                </el-form-item>
                <el-form-item label="Service" label-width="120px">
                    <el-select v-model="selectedService">
                        <el-option v-for="s in options" :key="s.value" :value="s.value" :label="s.label" />
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading.btnDelete" @click="doDeleteService"><i class="mdi mdi-delete"/> Delete</el-button>
                <el-button @click="dialog.delete = false">Close</el-button>
            </span>
        </el-dialog>
        <el-alert
            title="Info"
            type="info"
            :closable="false"
            description="If this account has not phone number and token, please Add Service from tab 'Detail' for the first time."
            show-icon>
        </el-alert>
        <div class="page-profile-edit mt-20" v-for="(data, idx) in dataServices.services" :key="idx" v-if="dataServices.services.length > 0">
            <el-card class="card-base scrollable only-y" style="color:white; background: linear-gradient(45deg, rgb(85,85,85,1) 0%, rgba(36, 147, 147) 100%);">
                <table>
                    <tbody>
                        <tr>
                            <td style="font-weight: bold">
                                <span>Phone Number</span><br><br>
                                <span v-if="data.service[0].name == 'line'" type="warning" style="color: #ffffff; border-radius:5px; font-weight:bold; font-size:18px; margin-top:30px; background-color:#333333; padding:10px;">{{ data.service[0].fields.bot.displayName }}</span>
                                <span v-else type="warning" style="color: #ffffff; border-radius:5px; font-weight:bold; font-size:18px; margin-top:30px; background-color:#333333; padding:10px;">{{ data.number }}</span>
                            </td>
                        </tr>
                    </tbody>
                    <br/>
                    <tbody>
                        <tr>
                            <td colspan="2" style="width: 10%; font-weight: bold">
                                Service
                                <span style="float:right; margin-right: 4px">
                                    <el-button size="mini" icon="el-icon-edit" type="default" @click="doShowDialogUpdate(idx)"></el-button>
                                    <el-button size="mini" icon="el-icon-delete" type="danger" @click="doShowDialogDelete(idx)"></el-button>
                                </span>
                            </td>
                        </tr>
                        <tr v-for="(dt, ky) in data.service" :key="ky">
                            <td colspan="2">
                                <dd>
                                    <table width="100%">
                                        <tr>
                                            <td width="35%">{{ capitalizeFirstLetter(dt.name) }}</td>
                                        </tr>
                                        <tr>
                                            <td width="35%">
                                                <dd style="font-weight: bold">Inquiry URL</dd>
                                            </td>
                                            <td>
                                                <dd><span type="warning" style="color: #ffffff; border-radius:5px; font-weight:bold; font-size:13px; margin-top:30px; background-color:#fff; padding:8px;"><a href="javascript:void(0)">{{ dt.inquiryUrl }}</a></span></dd>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="35%">
                                                <dd style="font-weight: bold">Token</dd>
                                            </td>
                                            <td>
                                                <dd>
                                                    <el-input disabled :rows="6" style="margin-top: 30px" type="textarea" :value="dt.fields.token"></el-input>
                                                </dd>
                                            </td>
                                        </tr>
                                        <tr v-if="dt.fields.botkit">
                                            <td colspan="2">
                                                <dd>
                                                    <table width="100%">
                                                        <tr>
                                                            <td style="font-weight: bold">Botkit</td>
                                                        </tr>
                                                        <tr v-if="dt.fields.botkit.hasOwnProperty('url')">
                                                            <td width="30%">
                                                                <dd><span style="display:block; border-radius:5px; margin-bottom:20px;">Url</span></dd>
                                                            </td>
                                                            <td>
                                                                <dd><span type="warning" style="display:inline-block; color: #ffffff; border-radius:5px; font-weight:bold; font-size:13px; margin-bottom:20px; background-color:#fff; padding:8px;"><a href="javascript:void(0)">{{ dt.fields.botkit.url }}</a></span></dd>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="dt.fields.botkit.hasOwnProperty('plain')">
                                                            <td width="30%">
                                                                <dd><span style="display:block; border-radius:5px; margin-bottom:20px;">Plain</span></dd>
                                                            </td>
                                                            <td>
                                                                <dd><span type="warning" style="display:inline-block; color: #249393; border-radius:5px; font-weight:bold; font-size:13px; margin-bottom:20px; background-color:#fff; padding:8px;">{{ dt.fields.botkit.plain ? "Yes" : "No" }}</span></dd>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="dt.fields.botkit.hasOwnProperty('close_callback')">
                                                            <td width="30%">
                                                                <dd><span style="display:block; border-radius:5px; margin-bottom:20px;">Close Callback</span></dd>
                                                            </td>
                                                            <td>
                                                                <dd><span type="warning" style="display:inline-block; color: #249393; border-radius:5px; font-weight:bold; font-size:13px; margin-bottom:20px; background-color:#fff; padding:8px;">{{ dt.fields.botkit.close_callback }}</span></dd>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="webhooks[idx]">
                                                            <td width="30%" style="vertical-align:top;">
                                                                <dd><span style="display:block; border-radius:5px; margin-bottom:20px;">Webhooks</span></dd>
                                                            </td>
                                                            <td>
                                                                <dd>
                                                                    <span type="warning" style="display:inline-block; white-space: pre-line; color: #249393; border-radius:5px; font-weight:bold; font-size:13px; margin-bottom:20px; background-color:#fff; padding:8px;">{{ webhooks[idx].join('\n') }}</span>
                                                                </dd>
                                                            </td>
                                                            <span style="float:right; margin-right: 4px">
                                                                <el-button size="mini" icon="el-icon-edit" type="default" @click="doShowDialogWebhooks(idx)"></el-button>
                                                            </span>
                                                        </tr>
                                                    </table>
                                                </dd>
                                            </td>
                                        </tr>
                                    </table>
                                </dd>
                            </td>
                        </tr>
                    </tbody>
                    <br>
                </table>
            </el-card>
        </div>
        <div v-else>
            <img src="../../assets/images/no_data.png" alt="No data image" class="img-center"/>
        </div>
    </div>
</template>
<script>
import config from '../../config'
import api from '@/networkClient'
export default {
    props: {
        loadingInit: {
            type: Boolean,
        },
        listServices: {
            type: Object
        },
        listWebhooks: {
            type: Array
        }
    },
    data() {
        return {
            helpdesk_position: "",
            bot_position: "",
            adminId: "",
            connection: "",
            fb_identity_id: "",
            maskingName: "",
            notes: "",
            phoneStatus : "",
            timeout: null,
            options_picBusiness: [],
            options_helpdesk:[{value: '', label: 'None'},{value: 'client', label: 'Client'},{value: 'partner', label: 'Partner'},{value: 'inside_damcorp', label: 'Inside Damcorp'},{value: 'outside_damcorp', label: 'Outside Damcorp'}],
            options_botPosition: [{value: '', label: 'None'},{value: 'client', label: 'Client'},{value: 'partner', label: 'Partner'},{value: 'inside_damcorp', label: 'Inside Damcorp'},{value: 'outside_damcorp', label: 'Outside Damcorp'}],
            options_connection:[{value: 'whitelist_ip', label: 'Whitelist IP'},{value: 'standard', label: 'Standard'}],
            options_phoneStatus: [{value: 'online', label: 'Online'},{value: 'offline', label: 'Offline'},{value: 'transferred', label: 'Transferred'}],
            options: [],
            botkit: {},
            dialog: {
                update: false,
                delete: false,
                webhooks: false
            },
            loading: {
                page: false,
                btnUpdate: false,
                btnDelete: false
            },
            dataServices: {
                service: []
            },
            selectedNumber: {
                number: "",
                service: {}
            },
            selectedService: "whatsapp",
            selectedServiceObj: {
                inquiryUrl: "",
                fields: {
                    token: "",
                    botkit: {
                        url: "",
                        plain: false,
                        close_callback: ""
                    }
                }
            },
            selectedWebhook: 0,
            selectedServiceWH: {
                inquiryUrl: "",
                fields: {
                    token: "",
                    botkit: {
                        url: "",
                        plain: false,
                        close_callback: ""
                    },
                    bot: {}
                }
            },
            webhooks: [],
            webhooks_fields: ['', '', '']
        }
    },
    methods: {
        async loadAdmin(page = null, search){
			// this.loadingConsumen = true
			var self = this
			await api({
				url:config.baseApi+'admin_credential?page=' + page + '&query=' + search,
				method:'GET'
			}).then(response => {
				if(response.data.ec != 200){
					// console.log('fatal error')
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					let admin = response.data.data.admin
					// console.log("dp_user",this.dp_user)
					// let dp_user = []
                    admin = admin.map(val => {
                        val.value = val.username
                        val.label = val.username.charAt(0).toUpperCase() + val.username.slice(1)

                        return val
                    })
					// console.log('admin',admin);
                    this.options_picBusiness = admin
				}
			}).catch(error => {
				console.log("Error",error)
			})
			// this.loadingConsumen = false
		},
        async getMaskingName(search){
            return new Promise(async (resolve, reject) => {
                await api({
                    url: config.baseApi+'bussiness/get-fb-identity',
                    method: 'GET',
                    params: {
                        page: null,
                        search: search
                    }
                }).then(({ data }) => {
                    // console.log(data.data.data);
                    let maping = data.data.data.length > 0 ? data.data.data.map(el => { 
                                let val = {...el}
                                val.value = el.maskingName
                                return val
                            }):[]
                    let links = maping.length > 0 ? _.uniqBy(maping, 'value'): maping;
                    resolve(links)
                }).catch(error => {
                    console.log(error);
                    resolve([])
                })
			});
            
        },
        handleSelect(item) {
            // console.log(item);
            // console.log(this.maskingName);
            this.selectedNumber.fb_identity_id = item.id
			// clearTimeout(this.timeout);
			// setTimeout(() => {
			// 	this.$refs.noLoi.$el.getElementsByTagName('input')[0].focus()
			// }, 300);
		},
        async querySearch(queryString, cb) {
			// console.log(queryString);
			if (queryString.trim() != '') {
                this.selectedNumber.fb_identity_id = ""
				clearTimeout(this.timeout);
				this.timeout = setTimeout(async () => {
					if (queryString.trim().length >= 1) {
					  await this.getMaskingName(queryString.trim()).then( res => {
						   let links = res
						   let results = queryString ? links.filter(this.createFilter(queryString)) : links;
							// call callback function to return suggestions
							cb(results);
					  })
					 
					}
				}, 500);
			}
			
		},
        createFilter(queryString) {
			return (link) => {
			return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
			};
		},
        capitalizeFirstLetter(string) {
			if(string == null || string == ""){
				return "-"
			} else {
                if(string.split("_").length > 0){
                    let title = []
                    _.map(string.split("_"), (str) => {
                        title.push(str.charAt(0).toUpperCase() + str.slice(1))
                    })
                    return title.join(" ")
                } else {
                    return string.charAt(0).toUpperCase() + string.substring(1);
                }
			}
        },
        isEmpty(obj) {
            for(var prop in obj) {
                if(obj.hasOwnProperty(prop))
                    return false;
            }

            return true;
        },
        async loadService(){
			let custId = this.$route.params.consumen
			this.loading.page = true
			await api({
				method: "get",
				url: config.baseApi + "consumen/" + custId + "/services"
			}).then(resp => {
                this.dataServices = resp.data.data
			}).catch(err => {
				console.log("failed", err)
			})
			this.loading.page = false
        },
        doShowDialogUpdate(key){
            // console.log(key);
            this.options = []
            for (const service of this.dataServices.services[key].service) {
                this.options.push({
                    value: service.name,
                    label: this.capitalizeFirstLetter(service.name)
                })
            }
            this.selectedNumber = this.dataServices.services[key]
            // console.log(this.selectedNumber);
            this.selectedService = this.dataServices.services[key].service[0].name
            this.adminId = this.dataServices.services[key].service[0].adminId || ""
            this.connection = this.dataServices.services[key].service[0].connection || ""
            this.selectedNumber.fb_identity_id = this.dataServices.services[key].service[0].fb_identity_id || ""
            this.maskingName = this.dataServices.services[key].service[0].maskingName || ""
            this.notes = this.dataServices.services[key].service[0].notes || ""
            this.phoneStatus = this.dataServices.services[key].service[0].phoneStatus || ""
            this.dialog.update = true
            //console.log('this.dataServices.services[key].service[0].name)
            
            this.handleChangeSelectedService()
        },
        async loadWebhooks() {
            this.loading.page = true
            const pWebhooks = []
            let data =
                this.dataServices &&
                this.dataServices.services
                    ? this.dataServices.services
                    : [];
            data.forEach(async (e, i) => {
                if (e.service[0].name === 'line') {
                    pWebhooks[i] = api({
                        url: e.service[0].inquiryUrl + 'webhook',
                        headers: { Authorization: `Bearer ${e.service[0].fields.token}` }
                    });
                }
            })
            this.webhooks = await Promise.all(pWebhooks)
                .then(res => res.map(e => e ? e.data.data.webhooks : e))
            this.loading.page = false
        },
        doShowDialogWebhooks(key) {
            this.selectedNumber = this.dataServices.services[key]
            this.selectedServiceWH = this.dataServices.services[key].service[0]
            this.selectedWebhook = key;
            this.webhooks_fields = ['', '', '']
            this.webhooks[key].forEach((e, i) => { this.webhooks_fields[i] = e })
            this.dialog.webhooks = true
        },
        async doUpdateWebhooks(svc) {
            this.webhooks_fields = this.webhooks_fields.filter(Boolean)
            // console.log('wh:', this.webhooks_fields)
            await api({
                method: 'patch',
                url: svc.inquiryUrl + 'webhook',
                headers: { Authorization: `Bearer ${svc.fields.token}` },
                data: { url: this.webhooks_fields }
            })
                .then(res => {
                    this.webhooks[this.selectedWebhook] = res.data.data.url
                })
                .then(() => this.$swal(this.$t('success'), this.$t('success'), "success"))
                .catch(() => this.$swal(this.$t('error'), this.$t('error_text'), "warning"))
            this.dialog.webhooks = false
        },
        WHField(i) {
            if (!this.webhooks_fields[i]) {
                for (let j = i; j < this.webhooks_fields.length; j++) {
                    this.webhooks_fields[j] = ''
                }
            }
        },
        doUpdateService(){
            let custId = this.$route.params.consumen
            // console.log(this.selectedNumber);
            if (!this.adminId || !this.connection || !this.maskingName || !this.phoneStatus) {
                this.$message.error({
                    showClose: false,
                    message: 'All field is required'
                });
                return
            }

            // if (!this.selectedNumber.fb_identity_id) {
            //     this.$message.error({
            //         showClose: false,
            //         message: 'Masking Name META not Valid'
            //     });
            //     return
            // }

            if (this.selectedService == 'helpdesk') {
                if (!this.helpdesk_position || !this.bot_position) {
                    this.$message.error({
                        showClose: false,
                        message: 'All field is required'
                    });
                    return
                }
            }

            this.$confirm("Update service for this number?", 'Confirmation', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                type: 'info',
                center: true
			}).then(async () => {

                

                this.loading.btnUpdate = true
                await api({
                    method: "patch",
                    url: config.baseApi + "consumen/" + custId + "/services",
                    data: {
                        helpdesk_position: this.helpdesk_position || null,
                        bot_position: this.bot_position || null,
                        adminId: this.adminId || null,
                        connection: this.connection || null,
                        // fb_identity_id: this.selectedNumber.fb_identity_id || null,
                        maskingName: this.maskingName || null,
                        notes: this.notes || null,
                        phoneStatus : this.phoneStatus || null,
                        number: this.selectedNumber.number,
                        serviceName: this.selectedService,
                        inquiryUrl: this.selectedServiceObj.inquiryUrl,
                        token: this.selectedServiceObj.fields.token,
                        ...(!this.isEmpty(this.botkit) && {botkit: this.botkit})
                    }
                }).then(resp => {
                    if(resp.data.ec == 200){
                        this.dialog.update = false
                        this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
                        this.loadService()
                    } else{
                        this.$swal(this.$t('error'), this.$t('error_text'), "warning").then()
                    }
                }).catch(err => {
                    this.$swal(this.$t('error'), this.$t('error_text'), "error").then()
                })
                this.loading.btnUpdate = false
            }).catch(cancel => {

            })
        },
        doShowDialogDelete(key){
            this.options = []
            for (const service of this.dataServices.services[key].service) {
                this.options.push({
                    value: service.name,
                    label: this.capitalizeFirstLetter(service.name)
                })
            }
            this.selectedNumber = this.dataServices.services[key]
            this.selectedService = this.dataServices.services[key].service[0].name
            this.dialog.delete = true
        },
        doDeleteService(){
            let custId = this.$route.params.consumen
            this.$confirm("Delete service for this number?", 'Confirmation', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                type: 'info',
                center: true
			}).then(async () => {
                this.loading.btnDelete = true
                await api({
                    method: "delete",
                    url: config.baseApi + "consumen/" + custId + "/services",
                    data: {
                        number: this.selectedNumber.number,
                        serviceName: this.selectedService
                    }
                }).then(resp => {
                    if(resp.data.ec == 200){
                        this.dialog.delete = false
                        this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
                        this.loadService()
                    } else{
                        this.$swal(this.$t('error'), this.$t('error_text'), "warning").then()
                    }
                }).catch(err => {
                    this.$swal(this.$t('error'), this.$t('error_text'), "error").then()
                })
                this.loading.btnDelete = false
            }).catch(cancel => {

            })
        },
        handleChangeSelectedService(val){
                let find = this.selectedNumber.service.find(el => el.name == val)
                if (find) {
                    this.adminId = find.adminId || null
                    this.connection = find.connection || null
                    this.selectedNumber.fb_identity_id = find.fb_identity_id || null
                    this.maskingName = find.maskingName || null
                    this.notes = find.notes || null
                    this.phoneStatus = find.phoneStatus || null

                    if (val == 'helpdesk') {
                        this.bot_position = find.bot_position || null
                        this.helpdesk_position = find.bot_position || null
                    }

                }
                

            //line
            this.selectedServiceObj = JSON.parse(JSON.stringify(
                _.find(this.selectedNumber.service, s => {
                    return s.name.toLowerCase() == this.selectedService.toLowerCase()
                })
            ))
            this.botkit = this.selectedServiceObj.fields.hasOwnProperty('botkit') ? 
                this.selectedServiceObj.fields.botkit : {}
        },
        handleChangeSelectedPicBusiness(val){
            // console.log(val);
        },
        clear(){
            this.selectedNumber = {
                number: "",
                service: []
            }
            this.selectedService = "whatsapp"
            this.botkit = {}
        }
    },
    async mounted(){
        await this.loadService()
        await this.loadWebhooks()
        await this.loadAdmin()
    },
    watch: {
        loadingInit(){
            this.loading.page = this.loadingInit
        },
        listServices(){
            this.dataServices = this.listServices
        },
        listWebhooks() { this.webhooks = this.listWebhooks}
    }
}
</script>

<style lang="scss" scoped>
.img-center {
    display: block;
    margin-bottom: 60px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 60px;
    width: 10%;
}
</style>